{
  "accessibilityLink": "Tillgänglighetsutlåtande",
  "accessibilityPage": "Tillgänglighetsutlåtande",
  "addComment": "Skriv en kommentar",
  "addCommentAndVote": "Rösta och skriv en kommentar",
  "addedFavorites": "Hörandet lades till favoriter.",
  "addFavorites": "Lägg till favoriter",
  "addGeojson": "Lägg till geojson som en fil",
  "addGeojsonInfo": "Observera att GeoJSON-formatet använder wgs84-koordinatsystemet. Spara endast en områdesgräns i filen.",
  "addOption": "Lägg till valalternativ",
  "addProcess": "Lägg till ny fas",
  "addSection": "Lägg till avsnitt",
  "additionalInfo": "Ytterligare information",
  "adminFilterSelectorLabel": "Filtrera hörander",
  "adminCommentMessage": "Du är inloggad som administratör. Ditt namn och din organisation kommer att visas tillsammans med din kommentar",
  "all": "Alla",
  "allHearings": "Alla höranden",
  "alreadyFavorite": "Hörandet finns redan i favoriter.",
  "alreadyVoted": "Du har redan röstat för denna kommentar.",
  "alreadyFlagged": "Den här kommentaren är redan flaggad.",
  "anonymous": "Anonym",
  "APICallFailed": "API-anropet {callName} misslyckades: {err}. Försök igen snart.",
  "asOpenData": "som öppna data",
  "attachment": "Bilaga",
  "attachments": "Bilagor",
  "backToHearingMain": "Tillbaka till hörandets hemsida",
  "borough": "Område",
  "cancel": "Avbryt",
  "characters": "tecken",
  "clear": "Klar",
  "close": "Stäng",
  "closedCount": "Stängda ({n})",
  "closedHearing": "Stängt",
  "closeHearing": "Stäng hörande",
  "commentConditions": "Uttryckta kommentarer publiceras {linkToDefinition} i tjänsten {linkToLicense}. Du kan lämna din kommentar anonymt om du inte har loggat in. Dessutom redigeras texter vid behov på grund av kränkande eller annars osakligt språkbruk.",
  "commentDeleted": "Din kommentar har strukits.",
  "commentEdited": "Din kommentar har redigerats. Tack!",
  "commentFlagged": "Den här kommentaren har flaggats.",
  "commentHearingStatus": "Hörandet är: ",
  "commentHelpAnswerOrCommentRequired": "Svara på minst en fråga eller skriv en kommentar.",
  "commentHelpNoPersonalInfo": "Lämna väl inte några personuppgifter i din kommentar.",
  "commentHelpStarRequired": "Obligatoriska fält är utmärkta med en asterisk (*).",
  "commentImageAlt": "Bild tillagd av kommenterare",
  "commentMapAdditionalInfo": "Ytterligare information relaterad till kartan (t.ex. adress)",
  "commentMapTitle": "Markera ditt förslag på kartan",
  "commentMapInstructions": "Du kan markera på kartan genom att välja ett markeringsvertyg som du kan rita med på kartan. Du kan radera markeringarna från kartan genom att klicka på sopkorgen och sedan på 'Radera allt'.",
  "commentOrder": "Organisera kommentarerna:",
  "commentReceived": "Din kommentar har mottagits. Tack!",
  "commentRegisteredUsersOnly": "Logga in för att kommentera.",
  "commentReportsButtonLabel": "Rapporter",
  "commentReportsClose": "Stäng",
  "commentReportsDownload": "Ladda",
  "commentReportsSelectFileType": "Välj en filtyp",
  "commentReportsTitle": "Kommentarsrapporter",
  "commentVoting": "Kommentarsröstning",
  "commentOrAnswerRequiredError": "Svara på minst en fråga eller skriv en kommentar.",
  "commentRequiredError": "Skriv en kommentar innan du skickar in.",
  "comments": "Åsikter",
  "sectionCommentDeletedMessage": "Inlägget har raderats{date}, eftersom det inte följde Säg din åsikt-tjänstens regler. https://kerrokantasi.hel.fi/info?lang=sv",
  "sectionCommentGenericDeletedMessage": "Meddelandet har raderats.",
  "sectionCommentSelfDeletedMessage": "Författaren tog bort sitt eget inlägg.",
  "sectionCommentEditedMessage": "Detta meddelande har redigerats av författaren.",
  "sectionCommentModeratedMessage": "Detta meddelande har redigerats eftersom det stred mot användarvillkoren för tjänsten. https://kerrokantasi.hel.fi/info?lang=sv",
  "commentShowMap": "Kartmarkering placerad. Visa på kartan",
  "commentsOnMap": "Åsikter på kartan",
  "commentsOutOf": "Visas {current}/{total} åsikter.",
  "commentStrongRegisteredUsersOnly": "Logga in med Suomi.fi-identifiering för att kommentera.",
  "commentSubsectionBtn": "Kommentera",
  "commentAndVoteSubsectionBtn": "Rösta och skriv en kommentar",
  "contactPersons": "Kontaktpersoner",
  "contactPersonOrganizationHelpText": "Om ingen organisation är definierad kommer din organisation att användas som standard.",
  "contactPersonAdditionalInfoHelpText": "Företag/Enhet som kontaktpersonen tillhör. Visas för användare istället för organisationsnamnet, om 'Externa aktörer' har valts som organisation",
  "contactTitle": "Jobbtitel eller rollbeskrivning",
  "contactTitlePlaceholder": "Ange kontaktpersonens jobbtitel eller rollbeskrivning...",
  "cookieManagementLink": "Cookie -inställningar",
  "copyHearing": "Kopiera hörande",
  "copyrightHolder": "Säg din äsikt (Kerrokantasi)",
  "copyrightText": "Alla rättigheter förbehållna.",
  "create": "Skapa",
  "createContact": "Skapa en ny kontakt",
  "CREATED_AT_ASC": "Äldsta först",
  "CREATED_AT_DESC": "Nyaste först",
  "createHearing": "Skapa nytt hörande",
  "createLabel": "Skapa en ny tagg",
  "dataProtection": "Dataskydd",
  "defaultClosureInfo": "Det här hörandet har stängts. Det är inte längre möjligt att uttrycka åsikter eller understöda åsikter.",
  "defaultProject": "Lägg till nytt projekt",
  "delete": "Stryk",
  "deleteAttachment": "Ta bort bilaga",
  "deleteComment": "Stryk kommentaren",
  "deleteConfirmation": "Är du säker på att du vill stryka kommentaren?",
  "deleteDraft": "Ta bort utkast",
  "deleteQuestion": "Ta bort fråga",
  "deleteSection": "Ta bort avsnitt",
  "descriptionTag": "Säg din åsikt. Var med och utveckla staden och delta i öppna höranden.",
  "disabledLink": "Inaktiverad länk",
  "downloadReport": "Ladda ner en sammanfattning av åsikterna i Excel-format",
  "downloadFileError": "Nedladdningen av filen misslyckades",
  "draft": "Utkast",
  "draftDeleted": "Utkastet har tagits bort",
  "draftNotPublished": "Utkast, ej publicerat",
  "drafts": "Utkast",
  "draftCount": "Utkast ({n})",
  "edit": "Redigera",
  "editContact": "Redigera kontakten",
  "editHearing": "Redigera",
  "email": "E-post",
  "employee": "Anställd",
  "errorSaveBeforeAttachment": "Spara först hörandet och lägg sedan till bilagorna",
  "eyeTooltip": "Detta hörande har inte publicerats och är inte offentligt synligt.",
  "eyeTooltipOpens": "Detta hörande kommer att publiceras",
  "favoriteHearings": "Favorithöranden",
  "feedbackLinkText": "Ge respons",
  "feedbackPrompt": "Utveckling ideer för Din åsikt ",
  "firstClosing": "Den som stängs först",
  "follow": "Följ",
  "footerLogoAlt": "Kerrokantasi (Säg din åsikt) logotyp",
  "formButtonAcceptAndAdd": "Acceptera och lägg till",
  "formCheckErrors": "Åtgärda formulärfel först",
  "fullscreenHeaderLogoAlt": "Kerrokantasi (Säg din åsikt) logotyp",
  "generalNo": "Nej",
  "generalYes": "Ja",
  "headerLogoAlt": "Kerrokantasi (Säg din åsikt) logotyp",
  "headerWriteCommentLink": "Skriv en kommentar",
  "headerOpenFrontPageLinks": "Öppna länkmenyn på startsidan",
  "hearing": "Hörande",
  "hearingAvailable-en": "Hearing available",
  "hearingAvailable-fi": "Kuuleminen saatavilla",
  "hearingAvailable-sv": "Hörandet tillgängligt",
  "hearingAvailableInLang-en": "in English",
  "hearingAvailableInLang-fi": "suomeksi",
  "hearingAvailableInLang-sv": "på svenska",
  "hearingArea": "Om hörandet inte omfattar hela staden, markera det exakta området för hörandet på kartan.",
  "hearingCardComment": "Kommentar",
  "hearingCardComments": "Kommentarer",
  "hearingCardFullWidthComment": "Kommentar",
  "hearingCardFullWidthComments": "Kommentarer",
  "hearingClosed": "Har stängts",
  "hearingClosingDate": "Stängningsdatum",
  "hearingClosingTime": "Stängningstid",
  "hearingClosingTimePlaceholder": "Välj...",
  "hearingClosureInfo": "Meddelande om stängning",
  "hearingCommenting": "Kommentering",
  "hearingCommentingMap": "Kart markering i kommentarerna",
  "hearingCommentingMapChoice1": "Icke i bruk",
  "hearingCommentingMapChoice2": "Markör markering",
  "hearingCommentingMapChoice3": "Markör, rektangel och polygon markering",
  "hearingContacts": "Kontakter",
  "hearingContactsPlaceholder": "Välj hörselkontakter",
  "hearingFormHeaderContainsErrors": " - innehåller fel",
  "hearingFormHeaderStep0": "Fel",
  "hearingFormHeaderStep1": "1. Hörandets grundläggande information",
  "hearingFormHeaderStep2": "2. Innehåll",
  "hearingFormHeaderStep3": "3. Karta",
  "hearingFormHeaderStep4": "4. Publiceringsinformation",
  "hearingFormHeaderStep5": "5. Projektfaser",
  "hearingFormNext": "Fortsätt",
  "hearingLabels": "Nyckelord",
  "hearingLabelsPlaceholder": "Välj lämpliga nyckelord för hörandet",
  "hearingLanguages": "Ange innehåll för hörande",
  "hearingListComment": "Kommentar",
  "hearingListComments": "Kommentarer",
  "hearingListNotPublished": "Opublicerad hörande,",
  "hearingMap": "Höranden på kartan",
  "hearingMapHeaderText": "Karta",
  "hearingNotFound": "Hörandet kunde inte hittas.",
  "hearingOnlyAvailableIn": "Hörandet finns endast",
  "hearingOnlyAvailableInLang-en": "på engelska",
  "hearingOnlyAvailableInLang-fi": "på finska",
  "hearingOnlyAvailableInLang-sv": "på svenska",
  "hearingOpeningDate": "Öppningsdatum",
  "hearingOpeningTime": "Öppningstid",
  "hearingPreviewLink": "Kopiera förhandslänk",
  "hearingPreviewLinkFailed": "Kopieringen misslyckades.",
  "hearingPreviewLinkSuccess": "Förshandslänken kopierad till urklipp.",
  "hearingPreviewLinkTooltip": "Kopiera förhandslänken till urklipp.",
  "hearings": "Höranden",
  "hearingsHeaderText": "Höranden",
  "hearingSlug": "Hörandets adress (fyll i slutdelen av adressen)",
  "hearingSlugPlaceholder": "exempel adress",
  "hearingSubsectionsTitle": "Underavdelningar",
  "hearingTranslationNotAvailable": "Det här hörandet har inte publicerats på svenska",
  "help": "Hjälp",
  "hideName": "Dölj namn",
  "hideReplies": "Göm",
  "iframeAddButton": "Lägg till iframe",
  "iframeFormFieldAllow": "Informationssäkerhet osv. ytterligare inställningar (allow)",
  "iframeFormFieldHeight": "Höjd i pixlar (height)",
  "iframeFormFieldScrolling": "Rullningslist (scrolling)",
  "iframeFormFieldSrc": "Källa (src)",
  "iframeFormFieldTitle": "Titel (title)",
  "iframeFormFieldWidth": "Bredd i pixlar (width)",
  "iframeHtmlCopyPaste": "Iframe kopiera och klistra in html",
  "iframeModalTitle": "iframe data",
  "imageAddButton": "Läg till bild",
  "imageFileUploadError": "Det uppstod fel i bilduppladdningen.",
  "imageModalTitle": "Bildinformation",
  "imageSizeError": "Bilden för stor, största tillåtna storleken är 1MB",
  "infoHeaderText": "Information om tjänsten",
  "infoPage": "Information om tjänsten",
  "inLanguage-en": "på engelska",
  "inLanguage-fi": "på finska",
  "inLanguage-sv": "på svenska",
  "jumpToSearchForm": "Gå till sökfältet",
  "jumpToSearchResults": "Gå till sökresultat",
  "labelListTagsTitle": "Taggar",
  "labelPlaceholder": "Ange taggens namn...",
  "lang-en": "English",
  "lang-fi": "Suomi",
  "lang-sv": "Svenska",
  "languageSwitchLabel": "Välj språk",
  "lastClosing": "Stängs sist",
  "lastClosed": "Stängt senast",
  "leastCommented": "Minst kommenterade",
  "linkLeadsToExternal": "(Länk leder till extern tjänst)",
  "list": "Lista",
  "login": "Logga in",
  "loginAttemptFailed": "Inloggning misslyckades. Försök igen om en liten stund.",
  "logInToAnswer": "Logga in för att rösta och see resultat",
  "loginToComment": "Logga in för att kommentera.",
  "loginToContinue": "Log in to continue",
  "loginToVoteComment": "Logga in för att rösta på kommentaren.",
  "logout": "Logga ut",
  "mainSection": "Huvudavsnitt",
  "maintenanceNotificationLabel": "Underhåll",
  "maintenanceNotificationText": "Den nya inloggningen av Helsingfors-profilen kommer att införas 15.5.",
  "maintenanceNotificationText2": "Inloggningsmetoderna för Google, YLE och Facebook kommer att tas bort. Samtidigt kommer de anställdas AD-autentisering att ändras. Efter ändringen kommer tjänsten Helsingfors-profilen att användas för inloggning, och användarna kommer att kunna hantera sina egna uppgifter i stadens olika digitala tjänster. I och med införandet av Helsingfors-profilen kommer åtkomsten till tidigare kommentarer som gjorts under inloggning att inaktiveras.",
  "maintenanceNotificationText3": "Förändringen kommer också att ta bort innehållsproduktionsrättigheter för anställda. För att kunna producera innehåll bör du ta dig tid att förnya dina innehållsproduktionsrättigheter.",
  "map": "Karta",
  "mapView": "Alla höranden på kartan",
  "mostCommented": "Mest kommenterade",
  "moveDown": "Flytta ner",
  "moveUp": "Flytta upp",
  "multipleChoiceQuestion": "Flervalsfråga (respondenten kan välja flera alternativ)",
  "name": "Namn",
  "nameAndOrganization": "Namn och organisation",
  "newestFirst": "Nyaste först",
  "newMultipleChoiceQuestion": "Lägg till flervalsfråga",
  "newSingleChoiceQuestion": "Lägg till fråga med ett val",
  "next": "Följande",
  "nickname": "Pseudonym",
  "noAddedComments": "Inga kommentarer tillagda",
  "noCommenting": "Ingen kommentering",
  "noCommentsAvailable": "Inga kommentarer",
  "noFavoriteHearings": "Inga favorithöranden",
  "noHearings": "Inga höranden kunde hittas",
  "noProject": "Inget projekt",
  "oldestFirst": "Äldsta först",
  "open-hearings-on-map": "Pågående höranden på kartan",
  "openCommenting": "Öppen kommentering",
  "openVoting": "Öppen omröstning",
  "openCount": "Öppna ({n})",
  "openFullscreenMap": "Öppna helskärmskartan",
  "openHearing": "Öppet",
  "openHearings": "Öppna höranden",
  "option": "Valalternativ",
  "orderHasBeenChanged": "hörande order har ändrats",
  "organization": "Organisation",
  "organizationHearings": "Organisationens höranden",
  "ownHearings": "Egna höranden",
  "partSection": "Underavsnitt",
  "phase": "Faserna i projektet",
  "phaseActive": "Aktiv",
  "phaseDescription": "Steg beskrivning",
  "phaseDuration": "Fas varaktighet",
  "phone": "Telefonnummer",
  "pinnedComment": "Fastnålad kommentar",
  "POPULARITY_ASC": "Minst populära först",
  "POPULARITY_DESC": "Populäraste först",
  "previous": "Föregående",
  "project": "Projekt:",
  "projectName": "Projektnamn",
  "projectSelection": "Om hörandet tillhör ett flerfasprojekt, välj projektet här.",
  "published": "Publicerad",
  "publishedHearings": "Offentliga",
  "publishHearing": "Godkänn för publicering",
  "publishHearingNow": "Publicera hörande",
  "publishingQueue": "Publiceringskö",
  "question": "Fråga",
  "questionHelpMulti": "Du kan välja ett eller flera alternativ.",
  "questionHelpSingle": "Du kan välja ett alternativ.",
  "questionOptionPlaceholder": "Text för valalternativ.",
  "questionTextPlaceholder": "Skriv här frågan du vill att medborgarna ska svara på.",
  "queueCount": "Väntar publicering ({n})",
  "register": "Registrera dig",
  "registered": "registrerad",
  "registeredStrongOnly": "Endast starkt autentiserade användare",
  "registeredUsersOnly": "Endast inloggade användare",
  "registeredUserCommentMessage": "Ditt namn eller pseudonym kommer att visas tillsammans med din kommentar. Du kan ta bort ditt namn eller pseudonym genom att rensa fältet.",
  "removedFavorite": "Hörandet togs bort från favoriter.",
  "removeFavoriteNotFound": "Hörandet finns inte i favoriter.",
  "removeFavorites": "Ta bort från favoriter",
  "reply": "Svara",
  "revertPublishing": "Avbryt publicering",
  "save": "Spara",
  "saveAndPreviewHearing": "Spara och förhandsgranska utkast",
  "saveFailed": "Sparandet misslyckades",
  "saveHearingChanges": "Spara ändringar",
  "search": "Sök",
  "searchLabels": "Sök bland ämnena",
  "searchPlaceholder": "Söka...",
  "searchTitles": "Sök bland rubrikerna",
  "sectionAbstract": "Kort inledning",
  "sectionAbstractPlaceholder": "Beskriv huvudämnet kortfattat här. Visas i början med större teckensnitt än övrigt textinnehåll.",
  "sectionCardSubsectionTitle": "Underavdelning",
  "sectionContent": "Innehåll",
  "sectionContentPlaceholder": "Det faktiska innehållet, till vilket du kan lägga till formatering, länkar och bilder",
  "sectionImage": "Bild",
  "sectionImageCaption": "Bildtext",
  "sectionImageHelpText": "Rekommenderad bildstorlek är 960 × 720 (Max. 1MB). Större bilder kommer att skalas till rekommenderad storlek.",
  "sectionImagePlaceholder": "Förklara eller komplettera bilden med en bildtext. Nämn fotografens namn om det behövs.",
  "sectionInformationTitle": "Information",
  "sectionTitle": "Avsnittets titel",
  "sectionTitlePlaceholder": "Lägg till en beskrivande titel för avsnittet.",
  "sectionTotalComment": "{n} kommentarer",
  "sectionTotalComments": "{n} kommentar",
  "selectHearingComments": "Välj ett hörande för att se dess kommentarer",
  "selectOrDropFile": "Välj eller släpp bilaga",
  "selectOrDropImage": "Välj eller släpp bild",
  "show": "Visa",
  "showAll": "Visa alla ({n})",
  "showMoreReplies": "Visa svar",
  "showOnlyOpen": "Endast öppna visas",
  "showSubsectionBtn": "Visa detaljer",
  "singleChoiceQuestion": "Fråga med ett val (respondenten väljer ett alternativ)",
  "skipLinkAddButton": "Lägg till hopplänk",
  "skipLinkFormFieldHide": "Dölj länk",
  "skipLinkFormFieldOwnId": "Länkens eget id",
  "skipLinkFormFieldTargetId": "Länkens mål-id",
  "skipLinkFormFieldText": "Länktext",
  "skipLinkModalTitle": "Hopplänk data",
  "skipToMainContent": "Gå till huvudinnehållet",
  "slugInUse": "Adressen du valde var i bruk och ändrades därför.",
  "sort": "Organisera",
  "scrollToTop": "Tillbaka till toppen",
  "submit": "Skicka",
  "subsectionTitle": "Underavdelning",
  "timeCloseFuture": "Stängs",
  "timeCloseFutureWithValues": "Stängs {date} kl. {time}",
  "timeClosePast": "Stängdes",
  "timeClosePastWithValues": "Stängdes {date} kl. {time}",
  "timeOpenFuture": "Öppnas",
  "timeOpenFutureWithValues": "Öppnas {date} kl. {time}",
  "timeOpenPast": "Öppnades",
  "timeOpenPastWithValues": "Öppnades {date} kl. {time}",
  "timetable": "Tidsschema",
  "title": "Rubrik",
  "titlePlaceholder": "Ge en beskrivande titel för hörandet.",
  "toBePublishedHearing": "Hörandet kommer att publiceras",
  "totalNumHearing": "{n} hörande",
  "totalNumHearings": "{n} höranden",
  "totalQuestionVotes": "Totalt antal röster: {n}",
  "totalSubmittedComment": "Totalt {n} åsikt",
  "totalSubmittedComments": "Totalt {n} åsikter",
  "toolbar": "Verktyg",
  "tryingToDeletePhaseWithHearings": "En fas som redan har höranden kan inte tas bort.",
  "unpublishedAttachments": "Bilagor kan inte laddas ner om hörandet inte är publicerat.",
  "userInfo": "Min Profil",
  "userAddedComments": "Mina kommentarer ({n} st)",
  "validationCantBeEmpty": "Det här fältet får inte vara tomt",
  "validationHearingCloseAt": "Ange stängningstid.",
  "validationHearingContactPersons": "Ange åtminstone en kontaktperson.",
  "validationHearingLabels": "Ange åtminstone ett ämnesord.",
  "validationHearingOpenAt": "Ange öppningstid.",
  "validationHearingProjectPhaseActive": "Projekt behöver åtminstone en aktiv fas.",
  "validationHearingProjectPhaseTitle": "Ange fasets titel.",
  "validationHearingProjectTitle": "Ange projekt namn.",
  "validationHearingSlug": "Ange adress.",
  "validationHearingTitle": "Ange rubrik.",
  "validationNotification": "Formuläret innehåller fel, korrigera felen och försök igen. ",
  "validationOnlyNumbers": "Det här fältet kan bara innehålla siffror",
  "vote": "Rösta",
  "voteButtonLikes": "Gillar",
  "voteButtonText": "Gillar den här kommentaren",
  "voteReceived": "Rösten mottagen. Tack!",
  "welcome": "Säg din åsikt",
  "welcomeMessage": "Var med och utveckla staden och delta i öppna höranden.",
  "withOpenLicense": "med öppen licens",
  "writeComment": "Kommentar",
  "externalContentBlocked": "Innehållet kan inte visas",
  "externalContentBlockedDescription": "Detta innehåll hämtas från adressen {url}. För att visa det måste du acceptera webbplatsens cookies. Du kan se innehållet antingen genom att gå till den externa webbplatsen eller genom att tillåta personaliserings- och statistikcookies i cookieinställningarna.",
  "openExternalSite": "Gå till extern webbplats",
  "editCookieSettings": "Redigera cookieinställningar",
  "openExternalSiteAriaLabel": "Öppna {domain} i nytt fönster",
  "editCookieSettingsAriaLabel": "Öppna cookieinställningar för att tillåta externt innehåll"
}
